//customElements.define("cart-items", CartItems);

document.addEventListener('DOMContentLoaded', () => {
  const patternContainer = document.getElementById('pattern-container');
  if (!patternContainer) return;

  // Global constants
  const addonInitializer = document.querySelectorAll('.pattern-initializer');
  const originalAddToCart = document.querySelector('.product-form__submit.button');
  const customAddToCart = document.querySelector('.custom-add');
  const variant = document.querySelector('.product-form form input[name="id"]');
  const originalPrice = document.querySelector('.price-wrapper');
  const sizeFieldset = document.querySelector('.size-fieldset');



  let variant_id = variant?.value;

  //if (variant_id) fetchVariantMetafieldValue(variant_id);
  if (variant_id) fetchVariantMetafields(variant_id);
  
  document.getElementById('yarnToggle').addEventListener('change', toggleAddonItems);

  addonInitializer.forEach(item => item.addEventListener('click', handleAddonInitializerClick));

  document.querySelectorAll('.size-fieldset input').forEach(item => {
    
    console.log('[INFO] - Size change');
    item.addEventListener('change', handleSizeVariantChange);
    
  });

  //customElements.define("cart-items", CartItems);
  const submitButton = document.querySelector('.custom-add');
  if (submitButton) {
    submitButton.addEventListener('click', handleAddToCart);
  }

  // Find the selected yarnType radio button on page load
  const selectedRadio = document.querySelector('input[name="yarn_quality"]:checked');
  if (selectedRadio) {
      console.log('Selected on page load:', selectedRadio.value);
      handleYarnSelection(selectedRadio.value);
  }

  function toggleAddonItems(event) {

    const isChecked = event.target.checked;
    patternContainer.style.display = isChecked ? "flex" : "none";
    originalAddToCart.style.display = isChecked ? "none" : "block";
    customAddToCart.style.display = isChecked ? "flex" : "none";
    originalPrice.style.opacity = isChecked ? "0" : "1";
    sizeFieldset.style.display = isChecked ? "block" : "none";
    
    if (isChecked) {
      yarnTypeRadioClick();
      //fetchVariantMetafieldValue(variant_id);
      fetchVariantMetafields(variant_id);
      distributeData();
    }
  }

  function handleAddonInitializerClick(event) {
    const clickedIniNumber = event.currentTarget.getAttribute('data-open');
    const specificContainer = document.querySelector(`.fixed-container[data-connect="${clickedIniNumber}"]`);
    const slideIn = specificContainer.querySelector('.slide-in');
    const connectedSlide = document.querySelector(`.p-${clickedIniNumber}-pattern`);

    document.querySelectorAll('.fixed-container').forEach(slide => slide.style.display = "none");

    slideIn.classList.add('active-slide');
    
    specificContainer.style.display = "flex";
    specificContainer.classList.remove('hide');
    connectedSlide.querySelector('.close').addEventListener('click', () => {
      specificContainer.style.display = "none";
    });
    console.log('OPEN PATTERN');
  }

  /**
   * Function to handle c
   */
  function handleSizeVariantChange() {
    setTimeout(() => {
      console.log('[INFO] - The size change');
      const variant_id = document.querySelector('.product-form form input[name="id"]').value;
      //fetchVariantMetafieldValue(variant_id)
        fetchVariantMetafields(variant_id)
        .then(distributeData)
        .then(() => {
          renderTotalPrice(); 
        })
        .catch(error => console.error('Error in processing:', error));
    }, 200);
  }


  function yarnTypeRadioClick() {
    // Add event listeners to all yarn-quality divs
    document.querySelectorAll('.yarn-quality').forEach(function(radioDiv) {
      radioDiv.addEventListener('click', function() {
        // Get the value from the input that corresponds to the clicked div
        const yarnType = this.getAttribute('data-yarn-type');
        const inputElement = document.querySelector(`input[id="${yarnType}"]`);
        
        if (inputElement) {
          const theValue = inputElement.value;
          // Log or do something with the clicked value
          console.log('Selected on click:', theValue);
          handleYarnSelection(theValue);

          // Optionally, check the corresponding radio input
          inputElement.checked = true;
        }
      });
    });
  }

  /**
   * 
   * @param {*} yarnValue 
   */
  function handleYarnSelection(yarnValue) {

    const addonInitializer = document.querySelectorAll('.pattern-initializer');
    
  
    // Hide all yarn-type containers
    const allYarnContainers = document.querySelectorAll('.yarn-type-container');
    allYarnContainers.forEach(container => {
      container.style.display = 'none';
    });
  
    // Show the selected yarn-type container
    const selectedYarnDivs = document.querySelectorAll(`.yarn-type-container[data-yarn-type-container="${yarnValue}"]`);
    selectedYarnDivs.forEach(yarnType => {
      yarnType.style.display = 'block';
      console.log('Yarn selected:', yarnValue);
  
      const yarnColorElements = yarnType.querySelectorAll('.yarn-color');
      let yarnColorFound = false;
  
      yarnColorElements.forEach(yarnColorElement => {
        if (!yarnColorFound && !yarnColorElement.classList.contains('yarn-sold-out')) {
          const label = yarnColorElement.querySelector('label');
          if (label) {
            label.click();
            yarnColorFound = true;
          }
        }
      });
  
      if (!yarnColorFound) {
        console.log('No available yarn colors found (all sold out).');
      }
    });
  }
  
  // Set initial Yarn color on DOM loaded
  setPreselectedYarn();

 /**
  * 
  * @param {*} yarnItemId 
  */
  function setYarnAsSoldOut(yarnItemId) {
    document.querySelectorAll(`.yarn-color[data-id="${yarnItemId}"]`).forEach(yarnElement => {
      yarnElement.querySelector('input').disabled = true;
      yarnElement.classList.add('yarn-sold-out');
    });
  }

  
  function checkYarnQuantityOnPageLoad(yarnItemId, parentId, pNumber) {
    const yarnInventory = window.yarnInventories[parentId]?.[yarnItemId];
    if (!yarnInventory) {
      console.error('No inventory data found for item:', yarnItemId);
      return false;
    }
    if (yarnInventory.quantity <= 0 && yarnInventory.policy === "deny") {
      console.log('Set as sold out:, ',yarnItemId);
      setYarnAsSoldOut(yarnItemId);
      return false;
    }

    return true;
  } 

 /**
  * 
  * @param {*} radio 
  * @param {*} pNumber 
  * @returns 
  */
  function errorHandlingOnChange(radio, pNumber) {
    const radioId = radio.value;
    const radioParentId = radio.getAttribute('data-main-id');
    const mainProductTitle = radio.getAttribute('data-main-title');
    const errorText = `It seems we don't have enough in stock of ${mainProductTitle} ${radio.getAttribute('data-option-value')}.<br>Please pick another color. If you have questions please call <b><a href='tel:+4528616763'>+45 28616763</a></b>`;

    if (!window.yarnInventories || !window.yarnInventories[radioParentId]?.[radioId]) {
      console.error('Inventory data missing for the selected radio button.');
      return false;
    }

    const yarnInventory = window.yarnInventories[radioParentId][radioId];
    const collectedYarn = document.querySelectorAll(`[data-open="${pNumber}"] .collected_yarn`);

    for (const element of collectedYarn) {
      const elementPcs = parseInt(element.getAttribute('data-pcs-pr-pattern'), 10);
      if (yarnInventory.quantity < elementPcs) {
        createContainer(errorText, 5000);
        return false;
      }
    }
    return true;
  }

  /**
   * Disttribute data for color after choosing a color
   */
  function distributeData() {
    //Loop through all the containers containing colors
    console.log('[INFO] - Distribute yarn data');
    

    document.querySelectorAll('.fixed-container').forEach(container => {
      const pNumber = container.getAttribute('data-connect');

      console.log('The P number: ',pNumber);
      document.querySelectorAll(`input[type="radio"][name="p-${pNumber}-pattern-yarnColor"]`).forEach(radio => {
        const radioParentId = radio.getAttribute('data-main-id');
        
        // Checks the yarn and sets sold out to unavailable
        checkYarnQuantityOnPageLoad(radio.value, radioParentId, pNumber);

        if (radio.checked) updateUIBasedOnSelectedRadio(radio, pNumber);
        radio.addEventListener('change', () => onRadioChange(radio, pNumber));
      });
    });
  }

  /**
   * Function that issues commands to different function upon any radio change for patterns
   * @param {*} radio 
   * @param {*} pNumber 
   * @returns 
   */
  function onRadioChange(radio, pNumber) {
    if (!errorHandlingOnChange(radio, pNumber)) return;

    console.log('COLOR CHANGED');
    const parentContainer = document.querySelector(`[data-connect="${pNumber}"]`);
    const slideInContainer = parentContainer.querySelector('.slide-in');

    // Remove the previous selected item
    parentContainer.querySelector('.yarn-color.selected')?.classList.remove('selected');

    // check the selected colors accross all selected colors
    updateUIBasedOnSelectedRadio(radio, pNumber);
    renderTotalPrice();

    // Clsoe the slide out after choosing yarn
    //parentContainer.style.display = "none";

    // Trigger slide-out animation for the slide-in container
    slideInContainer.classList.remove('active-slide');
    
    // Hide the overlay after the slide-out transition finishes
    slideInContainer.addEventListener('transitionend', function handleSlideOut() {
      parentContainer.classList.add('hide');
      slideInContainer.removeEventListener('transitionend', handleSlideOut);
    });
  } 

  /**
   * 
   * @param {*} radio 
   * @param {*} pNumber 
   */
  function updateUIBasedOnSelectedRadio(radio, pNumber) {
    var shopCurrency = Shopify.currency.active; 
    
    const addonInitializer    = document.querySelector(`.open-pattern-${pNumber}`);
    const totalPriceContainer = document.getElementById('total-price');
    const digitalPatternPrice = totalPriceContainer.querySelector('.price-item').getAttribute('data-pattern-price');
    const yarnSinglePrice     = parseFloat(radio.getAttribute('data-price'));
    const pcsPrPattern        = parseInt(document.querySelector(`.open-pattern-${pNumber} .collected_yarn`).getAttribute('data-pcs-pr-pattern'), 10);
    let yarnTypeString        = radio.getAttribute('data-main-title');
    const yarnTruePrice       = yarnSinglePrice * pcsPrPattern;
    const formattedYarnPrice  = yarnTruePrice/100;
    const finalPatternPrice   = (yarnTruePrice+parseFloat(digitalPatternPrice))/100;

    console.log('formatted price:, ', formattedYarnPrice);
    console.log('final pattern price; ', finalPatternPrice);
    radio.closest('.yarn-color')?.classList.add('selected');
    
    addonInitializer.querySelector('.yarn-price-container .yarn-price').setAttribute('data-unformatted-price', formattedYarnPrice);
    addonInitializer.querySelector('.yarn-price-container .yarn-price').innerText = formattedYarnPrice+" "+shopCurrency;
    addonInitializer.querySelector('.collected_yarn').setAttribute('data-collected-ids', radio.value);
    addonInitializer.querySelector('.yarn-type').innerText = yarnTypeString;
    addonInitializer.querySelector('.selected-yarn-info .name').innerText = radio.getAttribute('data-option-value');
    addonInitializer.querySelector('img').setAttribute('src', radio.getAttribute('data-image'));

   
  }

  function renderTotalPrice() {
    const patternPrices = document.querySelectorAll('.yarn-price');
    const totalPriceContainer = document.getElementById('total-price');
    let unformattedPrice = 0; 
    let digitalPatternPrice = 0;  
    if (totalPriceContainer) {
      digitalPatternPrice = parseFloat(
        totalPriceContainer
          .querySelector('.price-item')
          ?.getAttribute('data-pattern-price') ?? 0
      );
      digitalPatternPrice = digitalPatternPrice/100;
    }
    

    if(patternPrices){
      patternPrices.forEach(function(priceItem){
        unformattedPrice += parseFloat(priceItem.getAttribute('data-unformatted-price')); 
      });
    }
    console.log('FUll unformatted: ', unformattedPrice);
    unformattedPrice = unformattedPrice+digitalPatternPrice;
    
    const totalPriceItem = document.querySelector('#total-price .price-item');
    const formatter = new Intl.NumberFormat(`${Shopify.locale}-${Shopify.country}`, {
      style: 'currency',
      currency: Shopify.currency.active,
      minimumFractionDigits: 2
    });

    totalPriceItem.innerText = formatter.format(unformattedPrice);
  }

  /**
   * Fetches the variant meta data - the important data returned is pcs pr colli used to calculate price
   * 
   * @param {*} variant_id 
   * @returns 
   */
  async function fetchVariantMetafields(variant_id) {
    const res = await fetch(`https://${Shopify.shop}/api/2024-04/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': 'a5d7e5877a97b343a85b6b4871fe1b02',
      },
      body: JSON.stringify({
        query: `
          {
            node(id: "gid://shopify/ProductVariant/${variant_id}") {
              ... on ProductVariant {
                pcsPrPattern: metafield(namespace: "custom", key: "pcs_pr_pattern") { value }
                specificVariantData: metafield(namespace: "custom", key: "variant_product_data") { value }
              }
            }
          }
        `,
      }),
    });
  
    const { data } = await res.json();
    const { pcsPrPattern, specificVariantData } = data.node;
  
    /* ---------- pcs_pr_pattern ---------- */
    const rawPatternArr = JSON.parse(pcsPrPattern?.value ?? '[]');
    const patternArr = [null, ...rawPatternArr.slice(0, 4).map(v => (v !== null ? parseFloat(v) : v))];
  
    patternArr.forEach((val, idx) => {
      if (idx === 0) return;
      const str = val != null ? val.toString() : '';
  
      const yarn = document.querySelector(`[data-open="${idx}"] .collected_yarn`);
      yarn?.setAttribute('data-pcs-pr-pattern', str);
  
      const num = document.querySelector(`[data-open="${idx}"] .selected-yarn-info .number`);
      num && (num.textContent = `${str} pcs`);
    });
  
    /* ---------- specific_variant_data ---------- */
    const svd = JSON.parse(specificVariantData?.value ?? '{}');
  
    // Example: expose whole object on an element
    const holder = document.querySelector('[data-specific-variant]');
    holder?.setAttribute('data-specific-variant', JSON.stringify(svd));
  
    renderTotalPrice();
  }
  

  /**
   * 
   * @param {*} text 
   * @param {*} timer 
   */
  function createContainer(text, timer) {
    const container = document.createElement("div");
    container.id = "InfoContainer";
    container.innerHTML = text || "Done!";

    const closeButton = document.createElement("div");
    closeButton.className = 'close';
    closeButton.textContent = 'X';
    closeButton.addEventListener('click', () => container.remove());

    container.appendChild(closeButton);

    Object.assign(container.style, {
      backgroundColor: "#f1f1f1",
      color: "#33333",
      fontSize: "18px",
      padding: "30px 15px",
      position: "fixed",
      bottom: "20px",
      right: "20px",
      zIndex: "9",
      borderRadius: "4px",
      transform: "translateY(100%)",
      transition: "transform 0.5s, opacity 0.5s"
    });

    document.body.appendChild(container);

    container.offsetHeight;

    container.style.transform = "translateY(0)";
    container.style.opacity = "1";

    setTimeout(() => {
      container.remove();
    }, timer);
  }

  // Add event listener for each yarn-quality
  document.querySelectorAll('.yarn-quality').forEach(function(div) {
    div.addEventListener('click', function() {
      // Find the corresponding radio input by matching data-yarn-type
      const yarnType = this.getAttribute('data-yarn-type');
      const radioInput = document.querySelector(`input[value="${yarnType}"]`);
      
      // Check the corresponding radio input
      if (radioInput) {
        radioInput.checked = true;

        // Trigger a change event if needed (to apply any logic tied to change events)
        radioInput.dispatchEvent(new Event('change'));
      }
    });
  });


  
}); // END DOCUMENT CONTENT LOADED

/**
 * Initialise the colour legend and keep it in sync with the chosen variant.
 */
function setYarnProductColorChoice() {
  const radios      = document.querySelectorAll('.colour-fieldset [data-variant-radio]');
  const legend      = document.querySelector('.colour-fieldset .product-form__group-name');
  if (!radios.length || !legend) return;
  const nameOption  = document.querySelector('.colour-fieldset').getAttribute('data-option-name');

  // --- helper --------------------------------------------------------------
  const updateLegend = (radio) => {
    legend.textContent = `${nameOption}: ${radio.value}`;
  };

  // --- variant change ------------------------------------------------------
  radios.forEach(radio => {
    radio.addEventListener('change', e => updateLegend(e.target));
  });

  // --- first paint ---------------------------------------------------------
  const preselected = document.querySelector('.colour-fieldset [data-variant-radio]:checked') || radios[0];
  if (preselected) updateLegend(preselected);
}

/**
 * Set preselected yarn values 
 */
function setPreselectedYarn(){
  const preselectedItemsArray = document.getElementById('pattern-container');
    let preSelectedVariantSkuArray = [];
  
    if (preselectedItemsArray) {
      const dataAttr = preselectedItemsArray.getAttribute('data-preslected-yarn');
      if (dataAttr) {
        preSelectedVariantSkuArray = dataAttr
          .split(',')
          .map(item => item.trim());
  
        console.log('____PRE SELECTED YARN ARRAY____');
        console.log(preSelectedVariantSkuArray);
  
        connectNumber = 1;
        for (let index = 0; index < preSelectedVariantSkuArray.length; index++) {
          const patternContainer = document.querySelector(`[data-connect="${connectNumber}"]`);
          const preselectedSku = preSelectedVariantSkuArray[index];

          if (!patternContainer) continue;
          console.log('INDEX: ', index);
          console.log('[INFO - Preselected SKU] ', preselectedSku);
          console.log('PatternContainer: ', patternContainer);

          const preselectedYarnColor = patternContainer.querySelector(`.yarn-color[data-sku="${preselectedSku}"]`);
          console.log('preselectedYarnColor: ', preselectedYarnColor);
          
          if (!preselectedYarnColor) continue;
  
          const preselectedYarnInput = preselectedYarnColor.querySelector('.yarn-input');
          if (preselectedYarnInput) {
            preselectedYarnInput.checked = true;
            preselectedYarnInput.click();
          }
  
          const previouslySelected = patternContainer.querySelector('.yarn-color.selected');
          if (previouslySelected) {
            previouslySelected.classList.remove('selected');
          }
  
          preselectedYarnColor.classList.add('selected');
          connectNumber++;
        }
      }
    }
}


/**
 * Function that controls the functions nd other items related to adding to cart
 */ 
async function handleAddToCart() {
  const itemsToAdd = [];
  const collectedYarnElements = document.querySelectorAll('.collected_yarn');
  const productForm = document.querySelector('product-form.product-form');
  
  const mainPatternId = productForm.querySelector('input[name="id"]').value;
  const mainPatternTitle = productForm.getAttribute('data-main-title');
  const mainProductType = productForm.getAttribute('data-product-type')?.toLowerCase();


  if (mainProductType !== 'independent designer' && mainProductType !== 'independant designer') {
    itemsToAdd.push({ 
      id: mainPatternId, 
      quantity: 1,
      properties: { Pattern: `${mainPatternTitle}-${mainPatternId}` } 
    });
  }
  

  collectedYarnElements.forEach(item => {
    const itemQuantity = parseInt(item.getAttribute('data-pcs-pr-pattern'), 10);
    const itemId = item.getAttribute('data-collected-ids');
    itemsToAdd.push({
      id: itemId,
      quantity: itemQuantity,
      properties: { Pattern: `${mainPatternTitle}-${mainPatternId}` }
    });
  });

  if (itemsToAdd.length > 1) {
    try {
      const results = await bulkAddToCart(itemsToAdd);
  
      await updateCartQuantity(results);
      await updateCartTotalFromCartJS();
      
    } catch (error) {
      console.error("Error while adding items to cart:", error);
    }
  } else {
    alert("Du har ikke valgt nogle produkter endnu");
  }
  
}
 

/**
 * Function that adds the yarn and pattern to cart
 * @param {*} items 
 * @returns 
 */
async function bulkAddToCart(items) {
  const cartAddURL = '/cart/add.js';
  const results = [];
  for (const item of items) {
    try {
      const response = await fetch(cartAddURL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.id, quantity: item.quantity, properties: item.properties })
      });
      results.push(await response.json());
    } catch (error) {
      console.error("Error adding item to cart:", item.id, error);
    }
  }
  return results;
}

function checkYarnQuantityForPatternOnAddToCart(yarnItemId, requiredQuantity) {
  const yarnInventory = window.yarnInventories[yarnItemId];
  if (yarnInventory && yarnInventory.quantity >= requiredQuantity) {
    return true;
  } else {
    setYarnAsSoldOut(yarnItemId);
    return false;
  }
}

// Helper function to format money using Shopify globals if available.
function formatMoney(cents) {
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, Shopify.money_format);
  }
  // Fallback: simple USD formatting
  return (cents / 100).toFixed(2) + ',-';
}

// Function that fetches the cart state and updates the subtotal display.
async function updateCartTotalFromCartJS() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) {
      throw new Error('Failed to fetch cart data');
    }
    const cartData = await response.json();
    // Shopify returns the total in cents in the total_price property
    const totalCents = cartData.total_price;
    const formattedTotal = formatMoney(totalCents);

    const totalElement = document.querySelector('.totals__subtotal-value');
    if (totalElement) {
      totalElement.textContent = formattedTotal;
    } else {
      console.warn('Totals element not found');
    }
  } catch (error) {
    console.error('Error updating cart total:', error);
  }
}


/**
 * 
 * @param {*} results 
 */
async function updateCartQuantity(results) {

  console.log('ADDED:');
  console.log(results);
  // results is an array of cart item objects
  const cartDrawer = document.querySelector('cart-drawer');
  const drawerItems = document.querySelector('cart-drawer-items');
  const checkOutBtn = document.querySelector('.cart__checkout-button');

  let cartContainer = cartDrawer.querySelector('#CartDrawer-CartItems');

  // Remove any empty state markup
  const emptyState = cartDrawer.querySelector('.drawer__inner-empty');
  if (emptyState) {
    emptyState.remove();
  }

  // Ensure the cart container exists
  if (!cartContainer) {
    cartContainer = document.createElement('div');
    cartContainer.id = 'CartDrawer-CartItems';
    cartContainer.className = 'drawer__contents js-contents';
    cartDrawer.appendChild(cartContainer);
  }

  // Ensure there is a wrapper for the cart items
  let wrapper = cartContainer.querySelector('.drawer__cart-items-wrapper');
  if (!wrapper) {
    wrapper = document.createElement('div');
    wrapper.className = 'drawer__cart-items-wrapper';
    cartContainer.appendChild(wrapper);
  }

  // If you want to clear the existing items before inserting new ones,
  // uncomment the following line:
  // wrapper.innerHTML = '';

  // Loop through each item in the results array
  results.forEach((item) => {
    // Calculate the new index based on how many items are currently in the wrapper.
    const newIndex = wrapper.querySelectorAll('.cart-item').length + 1;

    // Build the HTML string for the cart item
    const itemHtml = `
      <div id="CartDrawer-Item-${newIndex}" class="cart-item">
        <div class="cart-item__inner-top">
          ${item.image ? `
            <div class="cart-item__media">
              <img class="cart-item__image" 
                   src="${item.image}?width=140" 
                   alt="${(item.featured_image && item.featured_image.alt) || item.title}" 
                   width="80" height="100" loading="lazy">
            </div>
          ` : ''}
          <div class="cart-item__details">
            <div class="cart-item__name--price--container">
              <a href="${item.url}" class="cart-item__name link-hover-arrow">
                <span>${item.product_title}</span>
              </a>
              ${item.original_price !== item.final_price ? `
                <div class="cart-item__discounted-prices">
                  <span class="visually-hidden">Regular price</span>
                  <s class="cart-item__old-price">${formatMoney(item.original_price)}</s>
                  <span class="visually-hidden">Sale price</span>
                  <span class="cart-item__final-price">${formatMoney(item.final_price)}</span>
                </div>
              ` : `
                <div class="cart-item__final-price">${formatMoney(item.original_price)}</div>
              `}
            </div>
            ${ (item.options_with_values && item.options_with_values.length) ? `
              <dl>
                ${item.options_with_values.map(option => `
                  <div class="product-option">
                    <dd>${option.value}</dd>
                  </div>
                `).join('')}
              </dl>
            ` : '' }
            ${ (item.discounts && item.discounts.length) ? `
              <ul class="discounts list-unstyled" role="list" aria-label="Discount">
                ${item.discounts.map(discount => `
                  <li class="discounts__discount">
                    ${discount.title}
                  </li>
                `).join('')}
              </ul>
            ` : '' }
            <div class="cart-item__quantity-wrapper">
              <quantity-input class="quantity">
               
                <input class="quantity__input" type="number" name="updates[]" 
                       value="${item.quantity}" min="0" 
                       disabled="disabled"
                       aria-label="Quantity for ${item.product_title}" 
                       id="Quantity-${newIndex}" data-index="${newIndex}">
               
              </quantity-input>
              <cart-remove-button id="CartDrawer-Remove-${newIndex}" data-index="${newIndex}">
                <button type="button" class="link" aria-label="Remove ${item.title}">
                  <!-- remove icon here -->
                </button>
              </cart-remove-button>
            </div>
            <div id="CartDrawer-LineItemError-${newIndex}" class="cart-item__error" role="alert">
              <small class="cart-item__error-text"></small>
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
                <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    `;

    

    // Insert the new item into the wrapper
    wrapper.insertAdjacentHTML('beforeend', itemHtml);
  });

  // Remove any styling for an empty cart and open the cart drawer if applicable
  cartDrawer.classList.remove("is-empty");
  drawerItems.classList.remove("is-empty");
  checkOutBtn.removeAttribute('disabled');
  if (typeof cartDrawer.open === "function") {
    cartDrawer.open();
  }
}



function setupReadMore() {
  const isDesktop = window.innerWidth >= 1000;
  const readMoreLinks = document.querySelectorAll(
    isDesktop ? ".desktop .read-more" : ".mobile .read-more"
  );

  function slideUp(element, duration = 300) {
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = `${element.offsetHeight}px`;
    element.offsetHeight; // force reflow
    element.style.height = '0';
    element.style.overflow = 'hidden';

    setTimeout(() => {
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
    }, duration);
  }

  function slideDown(element, duration = 300) {
    element.style.removeProperty('display');
    let display = window.getComputedStyle(element).display;
    if (display === 'none') display = 'block';

    element.style.display = display;
    const height = element.offsetHeight;

    element.style.height = '0';
    element.style.overflow = 'hidden';
    element.style.transition = `height ${duration}ms ease`;
    element.offsetHeight; // force reflow
    element.style.height = `${height}px`;

    setTimeout(() => {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
    }, duration);
  }

  readMoreLinks.forEach(link => {
    link.addEventListener('click', function () {
      const openNr = this.getAttribute('data-open-nr');
      console.log('Got number for open: ', openNr);
      const selector = `${isDesktop ? '.desktop' : '.mobile'} .read-more-description[data-open-nr="${openNr}"]`;
      console.log(' Check selector: ', selector);
      const readMoreDescription = document.querySelector(selector);

      if (readMoreDescription) {
        const isActive = readMoreDescription.classList.toggle("active");
        isActive ? slideDown(readMoreDescription) : slideUp(readMoreDescription);
      }
    });
  });
}

// add event listener to window
window.addEventListener('load', function(){
  setupReadMore();
  setYarnProductColorChoice();
})
 
// Initialize the function when the DOM is ready
//document.addEventListener("DOMContentLoaded", setupReadMore);
